
const CLOUDFLARE_IMAGES_URL = "https://imagedelivery.net/IvutU1rpCiBOV4XdJynSyQ"
const CLOUDFLARE_IMAGES_VARIANT = "public"

export const generateCloudflareImageUrl = (imageId) => {
  return `${CLOUDFLARE_IMAGES_URL}/${imageId}/${CLOUDFLARE_IMAGES_VARIANT}`
}